import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';

export const EQUIPMENT_CATALOGS_CRUD_ACTION_CONSTANTS =
	crudActionConstantsGenerator('EQUIPMENT_CATALOGS');
export const EQUIPMENT_CATALOGS_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	EQUIPMENT_CATALOGS_CRUD_ACTION_CONSTANTS
);
